import { forwardRef, useState, type InputHTMLAttributes } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "@nutrayan/ui";

type Props = Omit<InputHTMLAttributes<HTMLInputElement>, "type"> & {
  invalid?: boolean;
};

/** Password input with an accessible show/hide toggle. */
export const PasswordField = forwardRef<HTMLInputElement, Props>(function PasswordField(
  { invalid, ...rest },
  ref,
) {
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative">
      <Input
        ref={ref}
        type={visible ? "text" : "password"}
        className="pr-11"
        {...(invalid !== undefined ? { invalid } : {})}
        {...rest}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? "Hide password" : "Show password"}
        aria-pressed={visible}
        className="text-muted hover:text-ink focus-visible:ring-saffron absolute inset-y-0 right-0 flex items-center px-3 focus-visible:outline-none focus-visible:ring-2"
      >
        {visible ? <EyeOff size={18} aria-hidden /> : <Eye size={18} aria-hidden />}
      </button>
    </div>
  );
});
